// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SendBulkDocumentationPopup-module__label___mTRkc {
  color: #222;
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 8px;
}

.SendBulkDocumentationPopup-module__grid___kjZtV {
  display: grid;
  row-gap: 15px;
  column-gap: 40px;
  grid-template-columns: 1fr 1fr;
}

.SendBulkDocumentationPopup-module__error___nyDAn {
  color: #d32f2f;
  margin-top: 4px;
  margin-bottom: 12px;
  margin-left: 2px;
  font-size: 14px;
  height: 4px;
  display: block;
}

.SendBulkDocumentationPopup-module__buttonsContainer___jJIvK {
  gap: 16px;
  display: flex;
  padding: 30px;
  justify-content: end;
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}`, "",{"version":3,"sources":["webpack://./src/popups/SendBulkDocumentationPopup/SendBulkDocumentationPopup.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,8BAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,aAAA;EACA,aAAA;EACA,oBAAA;EACA,2CAAA;AACF","sourcesContent":[".label {\n  color: #222;\n  font-weight: 500;\n  font-size: 14px;\n  margin-bottom: 8px;\n}\n\n.grid {\n  display: grid;\n  row-gap: 15px;\n  column-gap: 40px;\n  grid-template-columns: 1fr 1fr;\n}\n\n.error {\n  color: #d32f2f;\n  margin-top: 4px;\n  margin-bottom: 12px;\n  margin-left: 2px;\n  font-size: 14px;\n  height: 4px;\n  display: block;\n}\n\n.buttonsContainer {\n  gap: 16px;\n  display: flex;\n  padding: 30px;\n  justify-content: end;\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `SendBulkDocumentationPopup-module__label___mTRkc`,
	"grid": `SendBulkDocumentationPopup-module__grid___kjZtV`,
	"error": `SendBulkDocumentationPopup-module__error___nyDAn`,
	"buttonsContainer": `SendBulkDocumentationPopup-module__buttonsContainer___jJIvK`
};
module.exports = ___CSS_LOADER_EXPORT___;
